import toUpper from "lodash/toUpper";
import { useEffect } from "react";
import { connect } from "react-redux";
import ErrorMessage from "../../../common/js/components/ErrorMessage";
import compOperations from "../comp/ducks/operations";
import listingOperations from "../listing/ducks/operations";
import { requestListingNonRequiredConstraints } from "../listing/ducks/validation";
import searchOperations from "../search/ducks/operations";
import { findAndValidateField } from "../utils/findAndValidateField";
import EVPDashboard from "./EVPDashboard";
import operations from "./ducks/operations";

const EVPDashboardContainer = (props) => {
    const { resetDashboardParams, getEVPDashboardData, getBrokerDashboardData, userProfile } = props;

    const handleBlurValidate = (section, id, value) => {
        return findAndValidateField(requestListingNonRequiredConstraints, id, value, section);
    };

    useEffect(() => {
        resetDashboardParams();
        getEVPDashboardData();
        getBrokerDashboardData();
    }, [userProfile.user]);

    return userProfile.role === "evp" ? (
        <EVPDashboard {...props} handleBlurValidate={handleBlurValidate} />
    ) : (
        <ErrorMessage />
    );
};

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer,
        userProfile: state.authReducer.userProfile,
        evpValues: state.dashboardReducer.evpValues,
        brokerValues: state.dashboardReducer.brokerValues,
        requestModal: state.listingReducer.requestModal,
        modalData: state.compReducer.modalData,
        errors: state.utilsReducer.errors,
        searchResults: state.utilsReducer.searchResults,
        autocompleteResults: state.searchReducer.autocompleteResults,
        dashboardParams: state.dashboardReducer.dashboardParams,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEVPDashboardData: () => {
            dispatch(operations.getEVPDashboardData());
        },
        getBrokerDashboardData: () => {
            dispatch(operations.getBrokerDashboardData());
        },
        handleChangeRegion: (e) => {
            dispatch(operations.getEVPDashboardData("Closed", e.target.value));
        },
        toggleRequestModal: (spaceType, transactionType) => {
            dispatch(listingOperations.toggleRequestModal(spaceType, transactionType));
        },
        searchProperty: (term) => {
            dispatch(searchOperations.searchPropertyAutocomplete(term));
        },
        handleCompInput: (path, value) => {
            dispatch(compOperations.handleCompInput(path, value));
        },
        selectProperty: (property) => {
            dispatch(compOperations.selectPropertyFromAutocomplete(property));
        },
        handleDashboardInput: (e) => {
            dispatch(operations.handleEvpDashboardInput(e.target.id, e.target.value));
        },
        resetDashboardParams: () => {
            dispatch(operations.resetDashboardParams());
        },
        updateSearchTerm: (value, searchType) => {
            dispatch(searchOperations.updateFilter("searchTerm", value, searchType));
        },
        handleSearchSubmit: () => {
            dispatch(searchOperations.executeSearch("property_modal"));
            dispatch(searchOperations.storeSearchRun(true, toUpper("property_modal")));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EVPDashboardContainer);
